import React from 'react';
import { useSelector } from 'react-redux';
import { selectHoveredNoFlyZoneId } from '@src/core/features/zones/redux';
import { ZoneCircleProps } from './types';
import { colorByType, options } from './styles';
import { Circle } from '@react-google-maps/api';
import { ZoneLabel } from '@src/core/features/zones/components/zones-control/components';

const STROKE_HIGHLIGHT = '#ffffff';
const STROKE_NORMAL_WEIGHT = 1;
const STROKE_HIGHLIGHT_WEIGHT = 1.25;

const ZoneCircle: React.FC<ZoneCircleProps> = (props) => {
  const { zone } = props;
  const hoveredNoFlyZoneId = useSelector(selectHoveredNoFlyZoneId);
  const isHovered =
    hoveredNoFlyZoneId != null && Number(hoveredNoFlyZoneId) === Number(zone.id);

  const lat = Number(zone.centerLatitude);
  const lng = Number(zone.centerLongitude);

  if (isNaN(lat) || isNaN(lng)) return null;

  const color = colorByType[zone.zoneType];

  return (
    <React.Fragment>
      <ZoneLabel zone={zone} />
      <Circle
        center={{ lat, lng }}
        radius={zone.radiusMeters}
        options={{ 
          ...options, 
          fillColor: color,
          fillOpacity: 0.3,
          strokeColor: isHovered ? STROKE_HIGHLIGHT : color,
          strokeWeight: isHovered ? STROKE_HIGHLIGHT_WEIGHT : STROKE_NORMAL_WEIGHT,
        }}
      />
    </React.Fragment>
  );
};

export default ZoneCircle;